export default __webpack_public_path__ + "static/media/letheCity_vodanova_extrait_2.52a63c21.mp4";